<template>
  <div>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <template v-slot:activator="{on}">
        <v-btn v-if="item == undefined" rounded small dark color="primary" v-on="on" @click="open">
          <v-icon small left>mdi-plus</v-icon>
          <span>tambah data</span>
        </v-btn>
        <div v-else>
          <v-tooltip top v-if="!isDelete">
            <template v-slot:activator="{on}">
              <v-btn @click="open" small icon color="success" v-on="on">
                <v-icon small dark>edit</v-icon>
              </v-btn>
            </template>
            <span>Edit data</span>
          </v-tooltip>
          <v-tooltip top v-else>
            <template v-slot:activator="{on}">
              <v-btn @click="hapus" small icon color="error" v-on="on">
                <v-icon small dark>delete</v-icon>
              </v-btn>
            </template>
            <span>Hapus data</span>
          </v-tooltip>
        </div>
      </template>
      <v-card class="pa-4">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-icon left>mdi-virus</v-icon>
          <span>Informasi Penyakit</span>
          <v-spacer></v-spacer>
          <v-row justify="center" align="center" class="mr-5">
            <v-tooltip top>
              <template v-slot:activator="{on}">
                <v-btn @click="submit" :loading="loading" small fab color="primary" v-on="on">
                  <v-icon small dark>save</v-icon>
                </v-btn>
              </template>
              <span>Simpan data ini.</span>
            </v-tooltip>
            <div class="mx-1"></div>
            <v-tooltip top>
              <template v-slot:activator="{on}">
                <v-btn @click="reset" small fab color="error" v-on="on">
                  <v-icon small dark>cancel</v-icon>
                </v-btn>
              </template>
              <span>Reset form.</span>
            </v-tooltip>
          </v-row>
          <v-btn icon @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mt-3 mb-7"></v-divider>
        <v-container fluid class="pa-9" v-if="tampil">
          <v-row justify="start" align="center">
            <span class="grey--text title">Penyakit</span>
          </v-row>
          <v-divider class="mt-3 mb-5"></v-divider>
          <v-row class="pa-5">
            <v-container fluid>
              <v-form ref="form" class="pa-5">
                <v-text-field
                  label="Kode Penyakit"
                  hint="Isikan kode penyakit contoh : P-011"
                  prepend-icon="lock"
                  v-model="data.kode"
                  :rules="rKode"
                  outlined
                  dense
                ></v-text-field>
                <v-text-field
                  label="Nama Penyakit"
                  hint="Isikan nama penyakit"
                  prepend-icon="mdi-bacteria"
                  v-model="data.nama"
                  :rules="rNama"
                  outlined
                  dense
                ></v-text-field>
                <v-textarea
                  label="Keterangan"
                  hint="Isikan keterangan penyakit"
                  prepend-icon="mdi-text"
                  v-model="data.keterangan"
                  :rules="rKet"
                  outlined
                  dense
                ></v-textarea>
                <v-textarea
                  label="Pengendalian"
                  hint="Isikan pengendalian penyakit"
                  prepend-icon="mdi-text"
                  v-model="data.pengendalian"
                  :rules="rKet"
                  outlined
                  dense
                ></v-textarea>
              </v-form>
            </v-container>
          </v-row>
          <v-row justify="start" align="center">
            <span class="grey--text title">Gejala</span>
          </v-row>
          <v-divider class="mt-3 mb-5"></v-divider>
          <v-row v-for="(g, index) in selectedGejala" :key="index" align="center">
            <v-checkbox v-model="g.selected" :ref="g.gejala.id" :label="getLabel(g.gejala)"></v-checkbox>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import fs from "@/fb";
import Swal from "sweetalert2";
export default {
  props: ["item", "isDelete"],
  data() {
    return {
      selectedGejala: [],
      rKode: [
        v => !(v.length < 4) || "Kode tidak valid",
        v => !(v.substr(0, 2) != "P-") || "Kode tidak valid"
      ],
      rNama: [v => !(v.length < 5) || "Nama penyakit tidak valid"],
      rKet: [v => !(v.length < 10) || "Keterangan tidak valid"],
      dialog: false,
      loading: false,
      tampil: true,
      data: {
        kode: "",
        nama: "",
        keterangan: "",
        pengendalian: ""
      }
    };
  },
  mounted() {
    fs.gejala.orderBy("kode").onSnapshot(snapshot => {
      this.selectedGejala = [];
      snapshot.forEach(doc => {
        this.selectedGejala.push({
          gejala: {
            id: doc.id,
            ...doc.data()
          },
          selected: false
        });
      });
    });
  },
  computed: {},
  methods: {
    gantiTampilan: function() {
      this.tampil = false;
      setTimeout(() => {
        this.tampil = true;
      }, 1);
    },
    getLabel: function(gejala) {
      return gejala.keterangan + " [" + gejala.kode + " / " + gejala.nama + "]";
    },
    close: function() {
      this.$emit("onChange");
      this.dialog = false;
    },
    open: function() {
      this.reset();
      if (this.item == undefined) {
        this.reset();
      } else {
        this.data = { ...this.item };
        delete this.data.id;
      }
      this.dialog = true;
    },
    reset: function() {
      this.data = {
        kode: "",
        nama: "",
        keterangan: "",
        pengendalian: ""
      };
      if (!this.item) {
        // tidak ada data, maka reset data selected
        for (let i = 0; i < this.selectedGejala.length; i++) {
          this.selectedGejala[i].selected = false;
        }
      } else {
        this.data = { ...this.item };
        delete this.data.id;
        // split data gejala yang ada
        const arr = this.item.listGejala.split(","); // list kode gejala yang ada
        arr.forEach(kode => {
          for (let i = 0; i < this.selectedGejala.length; i++) {
            if (this.selectedGejala[i].gejala.kode == kode) {
              this.selectedGejala[i].selected = true;
            }
          }
        });
      }

      this.gantiTampilan();
    },
    hapus: async function() {
      try {
        // kode untuk menghapus data
        const y = await Swal.fire({
          icon: "question",
          text: "Anda yakin ingin ingin menghapus data ini ?",
          title: "Delete",
          showCancelButton: true,
          cancelButtonText: "Tidak",
          cancelButtonColor: "teal",
          confirmButtonText: "Ya",
          confirmButtonColor: "red"
        });

        if (y.value) {
          Swal.fire("Info", "Menghapus data ...", "info");
          Swal.showLoading();
          await fs.gejala.doc(this.item.id).delete();
          await Swal.close();
          Swal.fire("Info", "Data tersebut telah dihapus.", "success");
          this.$emit("onChange");
        }
      } catch (e) {
        console.log(e);
      }
    },
    submit: async function() {
      try {
        if (this.$refs.form.validate()) {
          // buat daftar gejala yang dipilih
          let listGejala = "";
          for (let i = 0; i < this.selectedGejala.length; i++) {
            if (this.selectedGejala[i].selected) {
              listGejala += this.selectedGejala[i].gejala.kode + ",";
            }
          }
          if (listGejala.length > 1) {
            listGejala = listGejala.substring(0, listGejala.length - 1);
          } else {
            Swal.fire(
              "Error",
              "Maaf, anda harus memilih minimal 1 gejala",
              "warning"
            );
            return -1;
          }
          this.data.listGejala = listGejala;

          if (this.item != undefined) {
            // edit data
            Swal.fire("Info", "Memperbarui data ...", "info");
            Swal.showLoading();
            await fs.penyakit.doc(this.item.id).update({ ...this.data });
            await Swal.close();
            this.reset();
            this.dialog = false;
            Swal.fire(
              "Sukses",
              "Data penyakit berhasil diperbarui.",
              "success"
            );
          } else {
            // tambah data
            Swal.fire("Info", "Mengecek data ...", "info");
            Swal.showLoading();
            const cek = await fs.penyakit
              .where("kode", "==", this.data.kode)
              .get();
            await Swal.close();
            if (cek.size > 0) {
              // data sudah ada
              Swal.fire(
                "Info",
                "Maaf, data penyakit dengan kode tersebut sudah ada.",
                "warning"
              );
            } else {
              // input data
              Swal.fire("Info", "Mengentri data baru ...", "info");
              Swal.showLoading();
              await fs.penyakit.add({ ...this.data });
              await Swal.close();
              this.reset();
              this.dialog = false;
              Swal.fire(
                "Sukses",
                "Data penyakit baru berhasil ditambahkan.",
                "success"
              );
            }
          }
          this.$emit("onChange");
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>